import * as types from '../constants/action-types';

export const dismissMessage = () => ({
    type: types.GENERIC_MESSAGE_DISMISSED,
});

export const displayMessage = message => ({
    type: types.GENERIC_MESSAGE_DISPLAYED,
    message,
});